import { Tooltip } from "@mui/material";
import type React from "react";

interface TooltipIconProps {
    tooltipText?: string;
    children: React.ReactNode;
}

export const TooltipIcon: React.FC<TooltipIconProps> = ({ tooltipText, children }): JSX.Element => (
    <>
        {!tooltipText ? (
            <>{children}</>
        ) : (
            <Tooltip title={tooltipText}>
                <div>{children}</div>
            </Tooltip>
        )}
    </>
);
